import React from 'react';

export const ContentWrapper: React.FC<
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
> = ({ className, ...props }) => (
  <div className={`${className ?? ''} px-4 py-4 lg:p-8 `} {...props} />
);
